<h1 class="mat-h1">
  <ng-content></ng-content>
</h1>
